import BoxContainer from "@standard/components/BoxContainer/BoxContainer";
import { useParams } from "react-router-dom";
import { useState, memo } from "react";
import DataForm from "@standard/components/DataForm/DataForm";
import { DatasourceAPI } from "api";
import {
  AlertService,
  DateService,
  ErrorService,
  FormService,
  NumberService,
} from "@standard/services";
import { useEffect } from "react";
import { DropdownButton, Dropdown } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import FormInput from "@standard/components/FormInput/FormInput";
import TableForm from "@standard/components/TableForm";

export default function CustomerForm({ history, url }) {
  const { id, action } = useParams();
  const [buttons, setButtons] = useState([]);
  const [errors, setErrors] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [disabled, setDisabled] = useState(action === "view");
  const [documentTemplates, setDocumentTemplates] = useState([]);
  const [datasource, setDatasource] = useState({
    documentTemplate: [],
  });

  const defaultValues = {
    id: id,
    name: "",
    alias: "",
    province: "",
  };

  const reactHookForm = useForm({ defaultValues });

  useEffect(() => {
    if (id !== undefined) {
      retrieveData(id);
    }
  }, []);

  const retrieveData = (id) => {
    FormService.getRequest(url, id).then((result) => {
      const tables = [
        { name: "documentTemplate", value: result.documentTemplates },
      ];
      DatasourceAPI.getActiveDatasource(tables).then((datasourceResult) => {
        setDatasource((prev) => {
          return { ...prev, ...datasourceResult };
        });

        reactHookForm.reset(result);
        setDocumentTemplates(
          result.documentTemplates.map((documentTemplateId) => {
            return {
              key: documentTemplateId,
              values: {
                documentTemplateId: documentTemplateId,
              },
            };
          })
        );
        setIsLoading(false);
      });
    });
  };

  const saveData = (newData) => {
    setIsLoading(true);

    const params = { ...newData, id: id };
    params.documentTemplates = documentTemplates
      .filter((f) => f.values.documentTemplateId)
      .map((item) => item.values.documentTemplateId);

    FormService.submitRequest(url, params)
      .then(() => {
        setIsLoading(false);
        setErrors([]);
        history.push(`/${url}`);
      })
      .catch((err) => {
        console.log("Catch error", err);
        setIsLoading(false);
        setErrors(err);
      });
  };

  const onSubmit = (newData) => {
    AlertService.confirm("Do you want to save data").then((res) => {
      if (res === true) saveData(newData);
    });
  };

  const docuementTemplateFields = [
    {
      label: "Document Template",
      name: "documentTemplateId",
      type: "ddl",
      align: "center",
      datasource: datasource.documentTemplate,
    },
  ];

  const fields = [
    {
      label: "Name",
      name: "name",
      type: "label",
      col: 12,
    },
    {
      label: "Alias",
      name: "alias",
      type: "label",
      col: 12,
    },
    {
      label: "Province",
      name: "province",
      type: "label",
      col: 12,
    },
    {
      type: "custom",
      control: (
        <div className="col-12" key="documentTemplates">
          <TableForm
            fields={docuementTemplateFields}
            disabled={disabled}
            values={documentTemplates}
            label="Document Templates"
            onChange={(newDocumentTemplates) =>
              setDocumentTemplates(newDocumentTemplates)
            }
          />
        </div>
      ),
    },
  ];

  const fieldErrors = ErrorService.convertToArray(
    reactHookForm.formState.errors
  );

  return (
    <BoxContainer loading={isLoading} errors={errors.concat(fieldErrors)}>
      <DataForm
        refForm={reactHookForm}
        onSubmit={onSubmit}
        fields={fields}
        url={url}
        buttons={buttons}
        enableSave={!disabled}
      ></DataForm>
    </BoxContainer>
  );
}
